import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import hi from "./locales/hi.json";
import es from "./locales/es.json";
import ml from "./locales/ml.json";
import kn from "./locales/kn.json";
import te from "./locales/te.json";
import pa from "./locales/pa.json";
import bn from "./locales/bn.json";
import ta from "./locales/ta.json";
import or from "./locales/or.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "hi", label: "हिन्दी" },
  { code: "es", label: "Español" },
  { code: "bn", label: "বাংলা" },
  { code: "ta", label: "தமிழ்" },
  { code: "te", label: "తెలుగు" },
  { code: "kn", label: "ಕನ್ನಡ" },
  { code: "ml", label: "മലയാളം" },
  { code: "pa", label: "ਪੰਜਾਬੀ" },
  { code: "or", label: "ଓଡ଼ିଆ" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      hi: { translation: hi },
      es: { translation: es },
      bn: { translation: bn },
      ta: { translation: ta },
      te: { translation: te },
      kn: { translation: kn },
      ml: { translation: ml },
      pa: { translation: pa },
      or: { translation: or },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "hi", "es", "bn", "ta", "te", "kn", "ml", "pa", "or"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "vybe_language",
      caches: ["localStorage"],
    },
  });

export default i18n;
